import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page03',
  templateUrl: './armenia-page03.component.html',
  styleUrls: ['./armenia-page03.component.css']
})
export class ArmeniaPage03Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
